var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "invoice-tabs-parent", class: _vm.tabClasses },
    [
      _c(
        "div",
        { staticClass: "invoice-tabs-header app_tabs_header mb-5 font-outfit" },
        [
          _c(
            "ul",
            { staticClass: "invoice-tabs app_tabs_items flex" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "li",
                {
                  key: tab.name,
                  class: {
                    "px-3 py-2.5 cursor-pointer text-gray-400 text-lg flex items-center": true,
                    "invoice-active": _vm.activeTab === index,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveTab(index)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(tab.name) + " "),
                  tab.badge
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "invoice-badge badge w-4 h-4 rounded-full bg-gray-200 text-gray-500 text-center flex items-center justify-center ml-1",
                        },
                        [_vm._v(_vm._s(tab.badge))]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          !_vm.selectedRows.length
            ? _c(
                "div",
                { staticClass: "invoice-buttons" },
                [
                  !_vm.selectedRows.length
                    ? _c("UiButton", {
                        attrs: {
                          buttonText: "Download All",
                          buttonClasses: "px-2 pr-5 pl-3.5 customHeight",
                          variant: "white",
                        },
                        on: { click: _vm.downloadAllCSv },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("DownloadIcon", {
                                    staticClass: "w-4 h-4",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "hover-icon",
                              fn: function () {
                                return [
                                  _c("DownloadIcon", {
                                    staticClass: "w-6 h-6",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1908794626
                        ),
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.selectedRows.length > 0
            ? _c(
                "div",
                { staticClass: "invoice-buttons" },
                [
                  !_vm.hiddenDownload
                    ? _c("UiButton", {
                        attrs: {
                          buttonText: "Download Selected",
                          buttonClasses: "px-2 pr-5 pl-3.5 customHeight",
                          variant: "white",
                        },
                        on: { click: _vm.downloadSelected },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("DownloadIcon", {
                                    staticClass: "w-4 h-4",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "hover-icon",
                              fn: function () {
                                return [
                                  _c("DownloadIcon", {
                                    staticClass: "w-6 h-6",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1908794626
                        ),
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        { staticClass: "tab-content" },
        [_vm._t("tab-" + _vm.activeTab)],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }